import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { FaCalendarAlt, FaUserCircle, FaMapMarkerAlt } from "react-icons/fa";
import LoadMoreList from "../../../services/LoadMoreList";
import { redirectUrl } from "../../../services/GlobalUrls";

const formatDateTime = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
};

const IncidentLogsListMobile = ({ ...props }) => {
  const [incidentlogs, setIncidentLogs] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setIncidentLogs(props.incidentlogs || []);
  }, [props.incidentlogs]);

  const viewIncidentLogData = (incidentLog) => {
    const id = incidentLog.incident_log_id;
    if (id) {
      sessionStorage.setItem("incidentLogViewId", id);
      sessionStorage.setItem("incidentLogViewMode", "true");
      redirectUrl("/create-incident-log");
    }
  };

  // Search Filter - Start
  const matchesSearchText = (incidentLog) => {
    const searchText = inputValue.toLowerCase();
    return (
      (incidentLog.incident_log_service_user_name || "")
        .toLowerCase()
        .includes(searchText) ||
      (incidentLog.incident_log_accident_incident_location || "")
        .toLowerCase()
        .includes(searchText) ||
      (incidentLog.incident_log_accident_incident_datetime || "")
        .toLowerCase()
        .includes(searchText) ||
      (incidentLog.incident_log_accident_incident_report || "")
        .toLowerCase()
        .includes(searchText)
    );
  };

  const filterRows = incidentlogs ? incidentlogs.filter(matchesSearchText) : [];
  // Search Filter - End

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        {/* Search Start */}
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group form-group-default">
                <input
                  type="text"
                  name="search"
                  className="form-control"
                  placeholder="Search here"
                  onInput={(event) => setInputValue(event.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Search End */}
        <div className="col-lg-12 col-md-12 m-b0 wrapper">
          <LoadMoreList
            data={filterRows}
            initialCount={5}
            noDataMessage="No Result Found"
            renderItem={(incident_log, i) => (
              <ul
                className="nav navbar-nav border border-grey p-4 mb-2"
                style={{ borderRadius: "20px" }}
                key={i}
              >
                <li className="text-dark">
                  <FaCalendarAlt className="mr-1 text-primary" />{" "}
                  {formatDateTime(
                    incident_log.incident_log_accident_incident_datetime
                  )}
                </li>
                <li className="text-dark">
                  <FaUserCircle className="mr-1 text-primary" />{" "}
                  {incident_log.incident_log_service_user_name || "-"}
                </li>
                <li className="text-dark">
                  <FaMapMarkerAlt className="mr-1 text-primary" />{" "}
                  {incident_log.incident_log_accident_incident_location || "-"}
                </li>
                <li className="text-dark">
                  <a
                    className="btn btn-primary btn-sm pull-right mt-2 text-white"
                    onClick={() => viewIncidentLogData(incident_log)}
                  >
                    <i className="fa fa-eye"></i>
                  </a>
                </li>
              </ul>
            )}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    incidentlogs: state.incidentlogs.incidentlogs,
  };
};

export default connect(mapStateToProps)(IncidentLogsListMobile);